<template>
  <v-dialog :retain-focus="false" :value="sectionEditor.show" :width="1100" @input="handleClosePopup">
    <div style="background-color: #fff">
      <div class="header-modal">
        <v-card-title class="d-flex justify-space-between align-center" style="padding: 10px 0">
          <span style="color: #0081c7">{{ fields.title }}</span>
          <v-btn icon @click="handleClosePopup">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
      </div>

      <v-card-text style="max-height: 70vh; overflow-y: auto">
        <div class="mb-6">
          <label class="label-input">Section</label>
          <v-row>
            <v-col cols="12" md="8">
              <v-text-field v-model="fields.title" label="Name" />
            </v-col>
            <v-col cols="12" md="4">
              <v-checkbox v-model="fields.enableAnchor" label="Enable Anchor" />
            </v-col>
          </v-row>
        </div>

        <div class="mb-6">
          <div class="label-input">Section background</div>
          <div class="group-item">
            <v-row>
              <v-col cols="12" md="6">
                <div class="d-flex align-center gap-3">
                  <input
                    type="color"
                    style="width: 40px; height: 40px; margin-right: 12px"
                    :value="fields.textColor"
                    @change="e => (fields.textColor = e.target.value)"
                  />
                  <v-text-field v-model="fields.textColor" label="Text color" :hide-details="true" />
                </div>
              </v-col>
              <v-col cols="12" md="6">
                <div class="d-flex align-center gap-3">
                  <input
                    type="color"
                    style="width: 40px; height: 40px; margin-right: 12px"
                    :value="fields['background-section'].color"
                    @change="e => (fields['background-section'].color = e.target.value)"
                  />
                  <v-text-field v-model="fields['background-section'].color" label="Background" :hide-details="true" />
                </div>
              </v-col>
            </v-row>
            <v-row>
              <v-col md="6" cols="12">
                <v-checkbox v-model="fields.padding.top" label="Top padding" :hide-details="true" />
              </v-col>
              <v-col md="6" cols="12">
                <v-checkbox v-model="fields.padding.bottom" label="Bottom padding" :hide-details="true" />
              </v-col>
            </v-row>
          </div>
        </div>

        <div class="mb-6">
          <div class="label-input">Container content</div>
          <div class="group-item">
            <v-row>
              <v-col cols="12" md="4">
                <v-checkbox v-model="fields['container-content'].showStyle" label="Show style" />
              </v-col>
              <v-col cols="12" md="8">
                <div class="d-flex align-center gap-3">
                  <input
                    type="color"
                    style="width: 40px; height: 40px; margin-right: 12px"
                    :value="fields['container-content'].background"
                    @change="e => (fields['container-content'].background = e.target.value)"
                  />
                  <v-text-field v-model="fields['container-content'].background" label="Container background" />
                </div>
              </v-col>
            </v-row>
          </div>
        </div>

        <div class="mb-6">
          <div class="label-input">Title (top)</div>
          <div class="group-item">
            <v-checkbox
              v-model="fields['title-card'].showTitle"
              class="mb-2 mt-0"
              label="Show title block"
              :hide-details="true"
            />
            <ckeditor :editor="editor" v-model="fields['title-card'].html" :config="editorConfig" />
          </div>
        </div>

        <div class="mb-6">
          <div class="label-input">Left card image</div>
          <div class="group-item">
            <div>
              <UploadImage
                @callback="payload => (fields.rightCardImage = (payload && payload.imageSrc) || '')"
                :image="{ imageSrc: fields.rightCardImage }"
                :height="'160'"
                :typeUpload="'image'"
                @callbackDelete="() => (fields.rightCardImage = '')"
              />
            </div>
            <div class="mt-8">
              <v-select
                :value="fields.rightCardLayoutPosition"
                @change="handleChangeRightCardLayoutPosition"
                class="mt-4"
                :items="columnLayoutOptions"
                item-text="text"
                item-value="value"
                label="Left card row position"
                dense
                hide-details
              />
              <p class="hint-text">Left = appears first on the row; Right = second.</p>
            </div>
          </div>
        </div>

        <div class="mb-6">
          <div class="label-input">Right card</div>
          <div class="group-item">
            <v-row class="mb-3">
              <v-col cols="12" md="6">
                <div class="d-flex align-center gap-3">
                  <input
                    type="color"
                    style="width: 40px; height: 40px; margin-right: 12px"
                    :value="fields.leftHighlight"
                    @change="e => (fields.leftHighlight = e.target.value)"
                  />
                  <v-text-field v-model="fields.leftHighlight" label="Highlight background" :hide-details="true" />
                </div>
              </v-col>
            </v-row>
            <label class="label-input-sub">Title</label>
            <ckeditor :editor="editor" v-model="fields.leftCardTitle" :config="editorConfig" />
          </div>
        </div>

        <div class="mb-6">
          <div class="label-input">Tab header</div>
          <div class="group-item">
            <v-row>
              <v-col cols="12" md="4">
                <div class="d-flex align-center gap-3">
                  <input
                    type="color"
                    style="width: 36px; height: 36px; margin-right: 8px"
                    :value="fields.colorTabHeader"
                    @change="e => (fields.colorTabHeader = e.target.value)"
                  />
                  <v-text-field v-model="fields.colorTabHeader" label="Tab text color" dense />
                </div>
              </v-col>
              <v-col cols="12" md="4">
                <div class="d-flex align-center gap-3">
                  <input
                    type="color"
                    style="width: 36px; height: 36px; margin-right: 8px"
                    :value="fields.colorTabHeaderHover"
                    @change="e => (fields.colorTabHeaderHover = e.target.value)"
                  />
                  <v-text-field v-model="fields.colorTabHeaderHover" label="Active text color" dense />
                </div>
              </v-col>
              <v-col cols="12" md="4">
                <div class="d-flex align-center gap-3">
                  <input
                    type="color"
                    style="width: 36px; height: 36px; margin-right: 8px"
                    :value="fields.bgTabHeaderHover"
                    @change="e => (fields.bgTabHeaderHover = e.target.value)"
                  />
                  <v-text-field v-model="fields.bgTabHeaderHover" label="Active tab background" dense />
                </div>
              </v-col>
            </v-row>
          </div>
        </div>

        <div class="mb-4">
          <div class="d-flex justify-space-between align-center mb-2">
            <label class="label-input" style="margin-bottom: 0">Tabs</label>
            <v-btn small text color="primary" @click="handleAddTab">
              <v-icon size="16">mdi-plus</v-icon>
              <span>Add tab</span>
            </v-btn>
          </div>
          <v-expansion-panels accordion>
            <v-expansion-panel v-for="(item, i) in fields.listTab" :key="i">
              <v-expansion-panel-header>
                <div class="d-flex justify-space-between align-center">
                  <span>Tab {{ i + 1 }}</span>
                  <v-btn icon :disabled="fields.listTab.length <= 1" @click.stop="handleRemoveTab(i)">
                    <v-icon size="20" color="#ff6c6c">mdi-delete</v-icon>
                  </v-btn>
                </div>
              </v-expansion-panel-header>
              <v-expansion-panel-content>
                <v-text-field v-model="item.title" label="Tab label" class="mb-3" />
                <label class="label-input-sub">Main content</label>
                <ckeditor :editor="editor" v-model="item.titleContent" :config="editorConfig" />
                <label class="label-input-sub mt-4">Footer content</label>
                <ckeditor :editor="editor" v-model="item.footContent" :config="editorConfig" />
              </v-expansion-panel-content>
            </v-expansion-panel>
          </v-expansion-panels>
        </div>
      </v-card-text>

      <div class="footer-modal">
        <v-card-actions style="padding: 10px 0">
          <v-spacer />
          <v-btn min-width="100" depressed @click="handleClosePopup">Cancel</v-btn>
          <v-btn min-width="100" color="primary" @click="handleSave">Save</v-btn>
        </v-card-actions>
      </div>
    </div>
  </v-dialog>
</template>

<script>
import Editor from 'ckeditor5-custom-build/build/ckeditor';
import { ckeditorConfigFullToolbar } from '@/helpers/editor';
import UploadImage from '@/components/form/uploadFile/UpdateImage.vue';
import { updateHtmlFromData } from '@/views/website/products/components/description/common/html/update';

export default {
  name: 'CardVitalTabSectionEditor',
  components: { UploadImage },
  props: {
    sectionEditor: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      editor: Editor,
      editorConfig: ckeditorConfigFullToolbar,
      columnLayoutOptions: [
        { text: 'Left', value: 1 },
        { text: 'Right', value: 2 },
      ],
      fields: {
        title: 'Card Vital Tab',
        enableAnchor: false,
        textColor: '#000000',
        padding: { top: true, bottom: true },
        'background-section': { color: '#ffffff' },
        'container-content': { showStyle: false, background: '#ffffff' },
        'title-card': {
          showTitle: true,
          html: '<h2 style="text-align: center;">Lorem ipsum dolor, sit</h2>',
        },
        leftHighlight: '#eff6f9',
        leftCardTitle: '',
        rightCardImage: '',
        rightCardLayoutPosition: 1,
        leftCardLayoutPosition: 2,
        colorTabHeader: '#214a88',
        colorTabHeaderHover: '#ffffff',
        bgTabHeaderHover: '#214a88',
        listTab: [],
      },
    };
  },
  mounted() {
    this.fields = {
      ...this.fields,
      ...this.sectionEditor.sectionExtract,
    };
    if (!this.fields['title-card']) {
      this.fields['title-card'] = {
        showTitle: true,
        html: '<h2 style="text-align: center;">Lorem ipsum dolor, sit</h2>',
      };
    }
    if (!this.fields.listTab || !this.fields.listTab.length) {
      this.fields.listTab = [
        {
          title: 'tab 1',
          titleContent: '<h2>Title</h2><p>Content</p>',
          footContent: '<p>Footnote</p>',
        },
      ];
    }
  },
  methods: {
    handleClosePopup() {
      this.$emit('close');
    },
    handleSave() {
      const updateHtml = updateHtmlFromData.sectionCardVitalTab(this.sectionEditor.section.html, this.fields);
      this.$emit('update:section', {
        ...this.sectionEditor.section,
        title: this.fields.title,
        html: updateHtml,
      });
      this.$emit('close');
    },
    handleAddTab() {
      this.fields.listTab.push({
        title: 'New tab',
        titleContent: '<h2>Title</h2><p>Content</p>',
        footContent: '<p>Footnote</p>',
      });
    },
    handleRemoveTab(index) {
      if (this.fields.listTab.length <= 1) return;
      this.fields.listTab.splice(index, 1);
    },
    handleChangeRightCardLayoutPosition(value) {
      this.fields.rightCardLayoutPosition = value;
      if (value === 1) {
        this.fields.leftCardLayoutPosition = 2;
      } else {
        this.fields.leftCardLayoutPosition = 1;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.label-input {
  font-size: 18px !important;
  font-weight: 500;
  color: #000;
  margin-bottom: 10px;
  display: block;
}
.label-input-sub {
  font-size: 14px !important;
  font-weight: 500;
  color: #333;
  margin-bottom: 8px;
  display: block;
}
.header-modal {
  position: sticky;
  top: 0;
  left: 0;
  z-index: 999;
  background-color: #fff;
  padding: 0 16px;
  box-shadow: 0px 0px 12px #0000000f;
}
.footer-modal {
  position: sticky;
  padding: 0 16px;
  bottom: 0;
  left: 0;
  z-index: 999;
  background-color: #fff;
  box-shadow: 0px 0px 12px #0000000f;
}
.group-item {
  padding: 15px 10px;
  border-radius: 10px;
  border: 1px solid #e0e0e0;
}
.hint-text {
  font-size: 12px;
  color: #666;
  margin: 4px 0 0 0;
  line-height: 1.4;
}
.ck-editor__editable_inline {
  min-height: 120px;
}
</style>
